import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { Observable, of } from 'rxjs';
import { AuthService } from './auth.service';
import { MatDialog } from '@angular/material/dialog';
import { filter, map, switchMap, take } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class TokenGuard implements CanActivate {
  constructor(
    public authService: AuthService,
    public router: Router,
    public dialog: MatDialog
  ) { }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    
      const loginRoute = this.authService.getRedirectLoginRoute();

      return this.authService.isLoggedIn$.pipe(
        take(1),
        switchMap(isLoggedIn => {
          const tkCustom = sessionStorage.getItem("authCustomTkPass");
          if (!isLoggedIn && !tkCustom ) {
            return of(this.router.createUrlTree([loginRoute]));
          }
          sessionStorage.removeItem("authCustomTkPass");
          return this.authService.token$.pipe(
            filter(token => token !== null),
            take(1),
            map(token => {
              if (token) {            
                return true;
              } else {
                return this.router.createUrlTree([loginRoute]);
              }
            })
          );
        })
    );
  }
}
